import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MdDialogRef} from '@angular/material';
import * as htmlToImage from 'html-to-image';
import * as fileSaver from 'file-saver';
import {fromPromise} from 'rxjs/observable/fromPromise';
import * as moment from 'moment';
import {Grupo, PRECIO_PRINT_WIDTH} from '../general-interfaces';
import {environment} from '../../../../environments/environment';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'app-precios-to-img-dialog',
  templateUrl: './precios-to-img-dialog.component.html',
  styleUrls: ['./precios-to-img-dialog.component.scss'],
})
export class PreciosToImgDialogComponent implements AfterViewInit, OnDestroy {

  public DATA: Grupo[];
  varianzas: string[] = []

  logoLoaded = new BehaviorSubject<boolean>(false);
  logoSubscription = new Subscription();

  protected readonly PRECIO_PRINT_WIDTH = PRECIO_PRINT_WIDTH;
  protected readonly ASSETS_URL = environment.ASSETS_URL;

  date = '';

  public titulo: PrecioPrintTitle;

  constructor(
    private dialogRef: MdDialogRef<PreciosToImgDialogComponent>
  ) {}

  ngAfterViewInit() {
    this.logoSubscription.add(
      this.logoLoaded.asObservable().subscribe(loaded => {
        if (loaded) {
          this.printPrecios();
        }
      })
    );
  }

  ngOnDestroy() {
    this.logoSubscription.unsubscribe();
  }

  printPrecios() {
    /**
     * Nótese que en la imagen del logo del footer, si ocurre un error, la imagen se imprime sin importar que tenga dicho error
     * esto se incluye dado que es el unico asset que se debe cargar. En caso de haber mas assets se debe generar un array de
     * booleans para verificar que todos los assets se carguen antes de imprimir
     * */
    const node = document.getElementById('to-print');
    fromPromise(htmlToImage.toBlob(node, {pixelRatio: 2.5})).take(1).subscribe(blob => {
      fileSaver.saveAs(blob, `${this.titulo}_${moment().format('DD-MM-YYYY-HH-mm-ss')}`);
      this.dialogRef.close(true);
    }, error => {
      console.error(error);
      this.dialogRef.close(false);
    })
  }
}

export type PrecioPrintTitle = 'Mercado AGD' | 'Pizarras' | 'Dólar';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/precios-to-img-dialog/precios-to-img-dialog.component.ts